<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Customers from '@/services/Customers'
import Swal from "sweetalert2";
import store from "@/state/store";
import modalAddGroups from '@/components/modals/customers/modalAddGroups';


export default {
  components: {Layout, PageHeader, modalAddGroups},
  page: {
    title: "Groups",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Groups",
      items: [
        {
          text: "Users",
        },
        {
          text: "Groups",
          active: true,
          href: "/customers/groups",
        },
      ],
      csrf_token: localStorage.getItem('csrf_token'),
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      link_id: null,
      tableData: [],
      totalRowsGroup: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "timestamp",
      sortDesc: true,
      showHistory: false,
      active: true,
      groupsData: [],
      group_id : {} ,
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "total_members",
          label: "Total Members",
          sortable: true,
        },
        {
          key: "provider",
          label: "Provider",
          sortable: true,
        },
        {
          key: "created_by",
          label: "Created By",
          sortable: true,
        },
        {
          key: "active",
          label: "Active",
          sortable: true,
        },
        "action",
      ],
    };
  },
  async created() {
    await this.getGroups()
  },
  methods: {
    async getGroups() {
      const showHistory = this.showHistory === true ? 1 : 0;
      const active = this.active === true ? 1 : 0;
      try {
        this.isBusy = true;
        const response = await Customers.getGroups({
          params: {
            showHistory,
            active,
          },
        });
        this.tableData = response.data.data;
        this.totalRowsGroup = this.tableData.length;
        this.currentPage = 1;
      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRowsGroup = 0;
      } finally {
        this.isBusy = false;
      }
      this.$store.commit('settotalRowsGroup', this.tableData.length);
    },
    callModalAddGroups(data) {
      this.groupsData = data;
      this.$bvModal.show("add_groups");
    },

    onFiltered(filteredItems) {
      this.totalRowsGroup = filteredItems.length;
      this.currentPage = 1;
    },

  },
  middleware: "authentication",
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-12 col-md-12  float-start">
              <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                 @click="callModalAddGroups()">
                <i class="mdi mdi-plus me-2"></i>Add Groups
              </a>
            </div>
            <div class="row">
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-3">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="me-3 mb-0" for="groupsStatus">Inactive Groups</label>

                  <div class="form-check form-switch form-switch-lg mb-0">
                    <input v-model="active"
                           @change="getGroups"
                           type="checkbox"
                           class="form-check-input"
                           id="groupsStatus" />
                  </div>
                  <label class="mb-0" for="groupsStatus">Active Groups</label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :busy="isBusy"
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
                  @filtered="onFiltered"
              >
                <template v-slot:cell(total_members)="data">
                  <span>
                    {{ data.item.type === 'static' ? data.value : '/' }}
                  </span>
                </template>

                <template v-slot:cell(active)="data">
                  <span :class="{'text-success': data.item.active === 1, 'text-danger': data.item.active === 0}">
                    {{ data.item.active === 1 ? 'Active' : 'Inactive' }}
                  </span>
                </template>

                <!-- Custom cell template for action column -->
                <template #cell(action)="data">
                  <router-link
                      :to="{ path: `/customers/group_details/${data.item.group_id}` }"
                      title="View Group"
                      class="px-2 text-blue"
                      v-b-tooltip.hover
                  >
                    <i class="uil uil-eye font-size-18"></i>
                  </router-link>
                </template>

                <template #table-busy>
                  <div class="text-center text-muted my-4">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRowsGroup"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalAddGroups @onRefresh="getGroups"></modalAddGroups>

  </Layout>
</template>